import { useHasPermission } from '@/shared/hooks/useHasPermission/useHasPermission';
import { useAwaitingReceiptsCountQuery } from '@/shared/services/payments-desk-lookup/payments-desk-lookup.api';

/** The queue's own cadence, so the badge and the list agree within a poll. */
const POLL_MS = 30_000;

export interface AwaitingReceiptsCount {
  /** `undefined` until the first answer lands, and for an operator who may not ask. */
  count: number | undefined;
  isLoading: boolean;
}

/**
 * How many receipts members have sent that nobody has decided on (F3) — the
 * one number the portal has for "there is work on the payments desk". Worn by
 * the sidebar and drawn on the dashboard, from one cache.
 *
 * Withheld, not fired and refused, without `billing.read` (P21b): the sidebar
 * renders for every operator, and a 403 on every page load is a red herring.
 */
export function useAwaitingReceiptsCount(): AwaitingReceiptsCount {
  const { can } = useHasPermission();
  const mayRead = can('billing.read');

  const query = useAwaitingReceiptsCountQuery(undefined, {
    pollingInterval: POLL_MS,
    skip: !mayRead,
  });

  return {
    count: mayRead ? query.data : undefined,
    isLoading: mayRead && query.isLoading,
  };
}
